import getInstanceAxios from "../Request";

const baseDomain = process.env.REACT_APP_LUCKY_WHEEL;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
